import React__default, { useContext } from 'react';
import classNames from 'classnames';
import Styles from './CustomTab.module.scss.js';
import AppBtn from '../app-btn/AppBtn.js';
import { AppContext } from '../../app-context.js';

const CustomTab = ({ onClick, options, selectedTab, mainClassName, tabWrapperClassName, buttonClassName, isActiveCalssName }) => {
    const { isMobile } = useContext(AppContext);
    const renderContent = (option) => {
        if (option.component)
            return option.component;
        return (React__default.createElement(React__default.Fragment, null,
            option.icon && option.icon,
            isMobile && option.labelMobile ? option.labelMobile : option.label,
            option.count ? `(${option.count})` : ""));
    };
    return (React__default.createElement("div", { className: classNames(Styles.main, mainClassName) },
        React__default.createElement("div", { className: classNames(Styles.tabWrapper, tabWrapperClassName) }, options.map((data) => (React__default.createElement(AppBtn, { className: classNames(Styles.tabBtn, buttonClassName, selectedTab === data.id && Styles.isActive, selectedTab === data.id && isActiveCalssName), type: "link", onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(data.id), key: JSON.stringify(data.id) }, renderContent(data)))))));
};

export { CustomTab as default };
//# sourceMappingURL=CustomTab.js.map
